export default __webpack_public_path__ + "static/media/fdc.e2d832a8.png";